
import { Site } from "api/types/site";
import { t } from "i18next";
import { CONST } from "models/constants";
import LabeledField from "providers/labeledField";
import { useState } from "react";
import { MdEditDocument } from "react-icons/md";
import GenericCard from "widgets/cards/generic";
import SiteConfigurationDialog from "widgets/dialogs/siteConfoguration";
import CircleButton from "widgets/controls/buttons/circle-button";
import Badge from "widgets/shared/badge";
import { minutesToTimeString } from "util/datelib";

interface GeneralProps {
  site?: Site;
  onUpdate?: () => void;
}

const Escalation: React.FC<GeneralProps> = ({ site, onUpdate }) => {
  const [showSiteConfig, setShowSiteConfig] = useState(false);

  const handleClose = (refresh: boolean) => {
    setShowSiteConfig(false);
    if(refresh) {
      onUpdate();
    }
  }

  // Helper function to get escalation level details
  const getEscalationLevelDetails = (level: any, index: number) => {
    const time = level?.time ? minutesToTimeString(level.time) : t("site.escalation.no.time.set");
    const description = t("site.escalation.level", { level: index + 1 });
    
    return {
      time,
      description,
    };
  };

  return (
    <>
    {showSiteConfig && <SiteConfigurationDialog context="escalation" site={site} isOpen={showSiteConfig} onClose={()=>{handleClose(false)}} onSuccess={()=>{handleClose(true)}}/>}
        <GenericCard
      title={t("site.escalation")}
      bgColor="500"
      extraTitle="text-white heading-md"
      topRight={
        <div className="-mt-2 flex items-center">
            <Badge label={site?.escalationConfig?.enabled ? t("site.escalation.enabled") : t("site.escalation.disabled")}
            color={site?.escalationConfig?.enabled ? "green" : "red"}
            sizes="sm"
            variant="fill"
            />
        <CircleButton
          icon={MdEditDocument}
          size="md"
          onClick={() => {
            setShowSiteConfig(true);
          }}
          variant="ghost"
          color="white"
          permissionRole={CONST.ROLE_OWNER}
            tooltip={t('tooltip.edit.escalation')}
              tooltipPlacement="bottom"
        />
        </div>
      }
    >
       <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-5">
          {site?.escalationConfig?.levels?.map((level, index) => {
            const details = getEscalationLevelDetails(level, index);
            return (
              <LabeledField className="text-txt-xs" textColor="white" label={details.description} id={`escalation-level-${index + 1}`}>
              <div className="text-txt-lg text-white">{details.time}</div>
              </LabeledField>
           
            );
          }) || (
            <>
             
            </>
          )}
          </div>
    </GenericCard>
    </>
   
  );
};

export default Escalation;
